// Shared helper — single source of truth for the default reference date.
// For company 4(Demo), dates are anchored to Dec 31, 2024 (their dataset is there).
// For all others, "now-3 months."
function getReferenceDate() {
  if (process.env.VUE_APP_COMPANY_ID === "4") {
    return new Date(2024, 11, 31);  // Dec 31, 2024 (month is 0-indexed!)
  }
  return new Date();
}

// Returns the default 3-month-backward window as YYYY-MM-DD strings.
function getDefaultDateRange() {
  const reference = getReferenceDate();
  const threeMonthsBefore = new Date(reference);
  threeMonthsBefore.setMonth(threeMonthsBefore.getMonth() - 3);

  return {
    minDate: threeMonthsBefore.toISOString().split("T")[0],
    maxDate: reference.toISOString().split("T")[0],
  };
}

export default class KdiagramCalculationData {
  constructor(
    speedRange,
    speedThroughWater,
    lowerHeatingValue,
    meanDraft,
    trim,
    trueWindSpeed,
    windDirection,
    fouling,
    date,
    minDate,
    maxDate,
    useLatestFouling
  ) {
    this.speedRange = speedRange;
    this.speedThroughWater = speedThroughWater;
    this.lowerHeatingValue = lowerHeatingValue;
    this.meanDraft = meanDraft;
    this.trim = trim;
    this.trueWindSpeed = trueWindSpeed;
    this.windDirection = windDirection;
    this.fouling = fouling;
    this.date = date;
    this.minDate = minDate;
    this.maxDate = maxDate;
    this.useLatestFouling = useLatestFouling;
  }

  static defaultData() {
    const { minDate, maxDate } = getDefaultDateRange();

    return new KdiagramCalculationData(
      [8, 15],
      "9,10,11,12,13",
      42700,
      10,
      0,
      3,
      0,
      0,
      maxDate,        // `date` — the reference, was new Date().toISOString().split("T")[0]
      minDate,        // `minDate`
      maxDate,        // `maxDate`
      false
    );
  }
}
